import { Widget, WidgetType } from '../types/widgetTypes.ts';

import { ClassNameOption } from '@/features/method-tester/types';

export const widgetList: Widget[] = [
  { id: '0', key: WidgetType.GenericUI },
  { id: '1', key: WidgetType.PaymentIntegration },
  { id: '2', key: WidgetType.Location },
  { id: '3', key: WidgetType.AuthCode },
  { id: '4', key: WidgetType.DeepLink },
  { id: '5', key: WidgetType.Payment },
  { id: '6', key: WidgetType.SystemInfo },
  { id: '7', key: WidgetType.CameraConsent },
  { id: '8', key: WidgetType.Consent },
  { id: '9', key: WidgetType.BankAccountToken },
  { id: '10', key: WidgetType.WifiInfo },
  { id: '11', key: WidgetType.LaunchUri },
];

enum ERROR_CODE {
  NO_PERMISSION = 300,
  NOT_FOUND_RESOURCE = 400,
  NETWORK_ERROR = 401,
  INCOMPLETE_PARAMETER = 200,
  INVALID_PARAMETER_TYPE = 201,
  PARMETERE_DATA_ERROR = 202,
  METHOD_NOT_IMPLEMENTED = 501,
}

enum ERROR_MESSAGE {
  NO_PERMISSION = 'No permission error',
  NOT_FOUND_RESOURCE = ' Resource not found error',
  NETWORK_ERROR = 'Network error',
  INCOMPLETE_PARAMETER = 'Incomplete parameter error',
  INVALID_PARAMETER_TYPE = 'Invalid parameter type error',
  PARMETERE_DATA_ERROR = 'Parameter data error',
  METHOD_NOT_IMPLEMENTED_ERROR = 'Method not implemented yet',
}

export const ERROR_CODE_MESSAGE_MAP: Record<
  string,
  { code: ERROR_CODE; message: ERROR_MESSAGE }[]
> = {
  authcode: [
    {
      code: ERROR_CODE.NOT_FOUND_RESOURCE,
      message: ERROR_MESSAGE.NOT_FOUND_RESOURCE,
    },
    {
      code: ERROR_CODE.NETWORK_ERROR,
      message: ERROR_MESSAGE.NETWORK_ERROR,
    },
  ],
  deeplink: [
    {
      code: ERROR_CODE.INCOMPLETE_PARAMETER,
      message: ERROR_MESSAGE.INCOMPLETE_PARAMETER,
    },
    {
      code: ERROR_CODE.INVALID_PARAMETER_TYPE,
      message: ERROR_MESSAGE.INVALID_PARAMETER_TYPE,
    },
    {
      code: ERROR_CODE.PARMETERE_DATA_ERROR,
      message: ERROR_MESSAGE.PARMETERE_DATA_ERROR,
    },
  ],
  payment: [
    {
      code: ERROR_CODE.INCOMPLETE_PARAMETER,
      message: ERROR_MESSAGE.INCOMPLETE_PARAMETER,
    },
    {
      code: ERROR_CODE.INVALID_PARAMETER_TYPE,
      message: ERROR_MESSAGE.INVALID_PARAMETER_TYPE,
    },
    {
      code: ERROR_CODE.PARMETERE_DATA_ERROR,
      message: ERROR_MESSAGE.PARMETERE_DATA_ERROR,
    },
    {
      code: ERROR_CODE.NETWORK_ERROR,
      message: ERROR_MESSAGE.NETWORK_ERROR,
    },
  ],
  location: [
    {
      code: ERROR_CODE.NO_PERMISSION,
      message: ERROR_MESSAGE.NO_PERMISSION,
    },
    {
      code: ERROR_CODE.NOT_FOUND_RESOURCE,
      message: ERROR_MESSAGE.NOT_FOUND_RESOURCE,
    },
  ],
  device: [
    {
      code: ERROR_CODE.NOT_FOUND_RESOURCE,
      message: ERROR_MESSAGE.NOT_FOUND_RESOURCE,
    },
    {
      code: ERROR_CODE.NETWORK_ERROR,
      message: ERROR_MESSAGE.NETWORK_ERROR,
    },
  ],
  camera: [
    {
      code: ERROR_CODE.NO_PERMISSION,
      message: ERROR_MESSAGE.NO_PERMISSION,
    },
    {
      code: ERROR_CODE.NOT_FOUND_RESOURCE,
      message: ERROR_MESSAGE.NOT_FOUND_RESOURCE,
    },
  ],
  bankToken: [
    {
      code: ERROR_CODE.NOT_FOUND_RESOURCE,
      message: ERROR_MESSAGE.NOT_FOUND_RESOURCE,
    },
    {
      code: ERROR_CODE.NETWORK_ERROR,
      message: ERROR_MESSAGE.NETWORK_ERROR,
    },
  ],
  consent: [
    {
      code: ERROR_CODE.INCOMPLETE_PARAMETER,
      message: ERROR_MESSAGE.INCOMPLETE_PARAMETER,
    },
    {
      code: ERROR_CODE.INVALID_PARAMETER_TYPE,
      message: ERROR_MESSAGE.INVALID_PARAMETER_TYPE,
    },
    {
      code: ERROR_CODE.PARMETERE_DATA_ERROR,
      message: ERROR_MESSAGE.PARMETERE_DATA_ERROR,
    },
  ],
};

export const SDK_CLASS_NAMES: ClassNameOption[] = [
  'GP',
  'GPApplication',
  'GPAudio',
  'GPBase',
  'GPBattery',
  'GPCall',
  'GPCamera',
  'GPCookie',
  'GPContacts',
  'GPFile',
  'GPImage',
  'GPLocation',
  'GPMiniAppAuth',
  'GPMotion',
  'GPNativeDetector',
  'GPNavigationBar',
  'GPNavigator',
  'GPNetwork',
  'GPNotification',
  'GPScan',
  'GPScreen',
  'GPScreenCapture',
  'GPStandardEventCenter',
  'GPStorage',
  'GPSystem',
  'GPUI',
  'GPUIActionSheet',
  'GPUIDialog',
  'GPUIToast',
  'GPVideo',
  'GPBluetooth',
].map((className) => ({
  id: className,
  key: className,
}));
